import React from 'react';
import { Link } from 'react-router-dom';
import { FaLock, FaMapMarkerAlt, FaMotorcycle, FaStore } from 'react-icons/fa';

const PICKUP_LOCATION = 'DigiRasa Kitchen Hub, Miyapur, Hyderabad';

/**
 * @param {{ address1?: string, address2?: string, city?: string, state?: string, pincode?: string }} form
 */
export function formatDeliveryAddressLines(form) {
  if (!form) return [];
  const lines = [];
  const street = [form.address1, form.address2].filter(Boolean).join(', ');
  if (street) lines.push(street);
  const locality = [form.city, form.state].filter(Boolean).join(', ');
  if (locality) lines.push(locality);
  if (form.pincode) lines.push(form.pincode);
  return lines;
}

/**
 * @param {{
 *   fulfillmentType: 'delivery' | 'pickup',
 *   addressLines?: string[],
 *   contactLine?: string,
 *   loading?: boolean,
 *   payDisabled?: boolean,
 *   onPayClick?: () => void,
 *   payLabel?: string,
 *   grandTotal?: number,
 *   isResumeMode?: boolean,
 * }} props
 */
const PaymentFulfillmentSummary = ({
  fulfillmentType,
  addressLines = [],
  contactLine,
  loading,
  payDisabled,
  onPayClick,
  payLabel,
  grandTotal = 0,
  isResumeMode,
}) => {
  const isPickup = fulfillmentType === 'pickup';

  return (
    <section className="payment-fulfillment" aria-labelledby="payment-fulfillment-title">
      <h2 id="payment-fulfillment-title" className="payment-fulfillment__title">
        {isPickup ? 'Pickup details' : 'Delivery address'}
      </h2>

      <div className="payment-fulfillment__card">
        <div className="payment-fulfillment__type">
          {isPickup ? <FaStore aria-hidden /> : <FaMotorcycle aria-hidden />}
          <span>{isPickup ? 'Pickup' : 'Delivery'}</span>
        </div>

        {isPickup ? (
          <div className="payment-fulfillment__body">
            <p className="payment-fulfillment__lead">
              <FaMapMarkerAlt aria-hidden />
              <span>{PICKUP_LOCATION}</span>
            </p>
            <p className="payment-fulfillment__hint">
              No delivery charges apply. Bring your order confirmation and registered mobile number
              when you collect.
            </p>
          </div>
        ) : addressLines.length > 0 ? (
          <div className="payment-fulfillment__body">
            <p className="payment-fulfillment__lead payment-fulfillment__lead--address">
              <FaMapMarkerAlt aria-hidden />
              <span>
                {addressLines.map((line) => (
                  <span key={line} className="payment-fulfillment__address-line">
                    {line}
                  </span>
                ))}
              </span>
            </p>
          </div>
        ) : (
          <p className="payment-fulfillment__hint">
            Delivery address is saved on your order. Contact support if you need to change it before
            paying.
          </p>
        )}

        {contactLine ? (
          <p className="payment-fulfillment__contact">
            <span className="payment-fulfillment__contact-label">Contact</span>
            {contactLine}
          </p>
        ) : null}
      </div>

      <p className="payment-fulfillment__razorpay-note">
        You will choose UPI, card, or other options securely on the Razorpay payment screen.
      </p>

      <div className="payment-fulfillment__actions checkout-summary-actions">
        <button
          type="button"
          className="checkout-pay-btn payment-fulfillment__pay"
          disabled={payDisabled}
          onClick={onPayClick}
        >
          <FaLock aria-hidden />{' '}
          {payLabel || `Pay ₹${loading ? '…' : grandTotal.toFixed(2)}`}
        </button>
        {isResumeMode ? (
          <Link
            to="/account/orders"
            className="checkout-back-btn checkout-back-btn--summary payment-back-link"
          >
            ← Back to My Orders
          </Link>
        ) : (
          <Link to="/checkout" className="checkout-back-btn checkout-back-btn--summary payment-back-link">
            ← Back to checkout
          </Link>
        )}
        <p className="checkout-security-note">🔒 Payments are processed securely via Razorpay.</p>
      </div>
    </section>
  );
};

export default PaymentFulfillmentSummary;
